export default __webpack_public_path__ + "static/media/eagles_logo_3.040183d8.png";